export const ENDPOINTS_CHARACTER = {
  GET_ALL: "/api/characters",
  POST: "/api/characters",
  PUT: (id: number) => `/api/characters/${id}`,
  DELETE: (id: number) => `/api/characters/${id}`,
  UPLOAD_IMAGE: (id: number, idstate: number) =>
    `/api/characters/${id}/state/${idstate}/upload-image`,
};

export const ENDPOINTS_OBSTACLE = {
  GET_ALL: "/api/obstacles",
  POST: "/api/obstacles",
  PUT: (id: number) => `/api/obstacles/${id}`,
  DELETE: (id: number) => `/api/obstacles/${id}`,
  UPLOAD_IMAGE: (id: number) => `/api/obstacles/${id}/upload-image`,
};

export const ENDPOINTS_SCENE = {
  GET_ALL: "/api/scenes",
  POST: "/api/scenes",
  PUT: (id: number) => `/api/scenes/${id}`,
  DELETE: (id: number) => `/api/scenes/${id}`,
  UPLOAD_IMAGE: (id: number) => `/api/scenes/${id}/upload-image`,
};

export const ENDPOINTS_SPRITE = {
  GET_ALL: "/api/sprites",
  GET_ALL_DETAILS: "/api/sprites/details",
  GET_BY_ID: (id: number) => `/api/sprites/${id}`,
  POST: "/api/sprites",
  PUT: (id: number) => `/api/sprites/${id}`,
  DELETE: (id: number) => `/api/sprites/${id}`,
  UPLOAD_IMAGE: (id: number) => `/api/sprites/${id}/upload-image`,
  POST_ANIMATIONS: `/api/sprites/animations`,
};

export const ENDPOINTS_TARGET = {
  GET_ALL: "/api/targets",
  POST: "/api/targets",
  PUT: (id: number) => `/api/targets/${id}`,
  DELETE: (id: number) => `/api/targets/${id}`,
  UPLOAD_IMAGE: (id: number, stateId: number) =>
    `/api/targets/${id}/state/${stateId}/upload-image`,
};

// Endpoints pour les IMAGES
export const ENDPOINTS_IMAGE = {
  GET_ALL: "/api/images",
  GET_BY_ID: (id: number) => `/api/images/${id}`,
  POST: "/api/images",
  PUT: (id: number) => `/api/images/${id}`,
  DELETE: (id: number) => `/api/images/${id}`,
  UPLOAD_IMAGE: (id: number) => `/api/images/${id}/upload-image`,
};

// Endpoints pour les SONS
export const ENDPOINTS_SOUND = {
  GET_ALL: "/api/sounds",
  GET_BY_ID: (id: number) => `/api/sounds/${id}`,
  POST: "/api/sounds",
  PUT: (id: number) => `/api/sounds/${id}`,
  DELETE: (id: number) => `/api/sounds/${id}`,
  UPLOAD_SOUND: (id: number) => `/api/sounds/${id}/upload-sound`,
};
